import { call, put, select, takeLatest, takeEvery, delay } from 'redux-saga/effects';
import * as actionTypes from '../actions/actionTypes';
import courseManagementServices from '../service/courseManagementServices';

import { courseManagementActions } from '../reducers/courseManagementReducer';
import { contentManagementAction } from '../reducers/contentMangementData';

import ACLService from '../../acl/services/aclService';
import { ActionType } from '../types/interfaces/ActionType';
import { SwitchCameraSharp } from '@material-ui/icons';
import { getUserSuggestions, publishCourse } from '../actions';
import { CourseActiveTabs } from '../types/enums/CourseActiveTabs';
import { CourseTypes } from '../types/enums/CourseTypes';
import { buildSKUString, checkForCreatedByUser, checkForPublishRight, getRequestId, redirectionToCourseListing, redirectionToCourseManagement } from '../helpers/helpers';
import { GeneralSettings, SEO } from '../types/interfaces/AdvancedSettings';
import { showMsg } from '../../course/actions/loaderAlert';
import { defaultDisplaySetting } from '../components/treeComponents/component/helpers/preSelectedFilters';
import { CONTENT_STATUS, MODULES } from '../../../constants/comman';
import {  showAlertToaster } from '../../test-template/actions/testTemplateActions';
import { VARIANT } from '../../common/types/ServerAlertDataV2';
import { API_RESPONSE, COURSE_PLAN_RESPONSES } from '../../mylibrary/constant';
import { REQUEST_STATUS } from '../types/enums/RequestStatus';
// import { fetchContentFromPackages } from '../actions/courseManagementActions';


// import any constants here

// ----------SAGAS GO BELOW-------------------
function* addCourseBasicDetailsSaga(action: ActionType) {
    // console.log(action);
    try {
        const res:any = yield call(courseManagementServices.addCourseBasicDetails, action.payload)
        console.log('DUPLICATE SKU:::::::::::::::::::',res);
        switch (res.statusCode) {
            case 200:
                yield put(
                    courseManagementActions.setIsCourseCreated(true)
                )
                yield put (
                    courseManagementActions.setPackageId(res.responseObject.packageDetails._id)
                )
               if(action.payload.type===CourseTypes.testSeries) 
                  yield put(courseManagementActions.setTestSeriesPackageId(res.responseObject.packageDetails._id));
                yield put(
                  courseManagementActions.setDuplicateSKUMessage([''])
                )
                break;
            case 422:
                    // console.log(':::::422:::::::')
                    yield put(
                      courseManagementActions.setDuplicateSKUMessage(['Please enter a unique SKU'])
                    )
                    yield put(
                      courseManagementActions.setIsCourseCreated(false)
                    )
                break;
            default:
                break;
        }
    } catch (e) {
        console.log(addCourseBasicDetailsSaga,e)
    }
}

function* updateCourseBasicDetailsSaga(action: ActionType) {
    try {
        const res = yield call(courseManagementServices.updateCourseBasicDetails, action.payload)
        console.log('updateCourseBasicDetailsSaga', res);
        switch(res.statusCode){
            case 200:
                yield put(
                    courseManagementActions.setIsCourseUpdated(true)
                )
                break;
            case 422:
                    courseManagementActions.setIsCourseUpdated(false)
                break;
            default:
                break;
        }
    } catch (e) {
        console.log('updateCourseBasicDetailsSaga',e)
    }
}

function* addCourseTestSeries(action: ActionType) {
  // console.log(action);
  try {
    const res: any = yield call(courseManagementServices.addCourseBasicDetails, action.payload);
    // console.log(res);
    switch (res.statusCode) {
      case 200:
        yield put(courseManagementActions.setIsCourseCreated(true));
        yield put(courseManagementActions.setTestSeriesPackageId(res.responseObject.packageDetails._id));
        break;
      case 422:
        // console.log('status422', res);
        courseManagementActions.setIsCourseCreated(false);
        break;
      default:
        break;
    }
  } catch (e) {
    console.log('Error in addCourseTestSeries', e);
  }
}
function* getActiveGoalsSaga(action: ActionType) {
  try {
    // console.log('inside goalsSaga');
    const res = yield call(courseManagementServices.getActiveGoals);
    yield put(courseManagementActions.setActiveGoals(res));
  } catch (e) {
    console.log(getActiveGoalsSaga, e);
  }
}

function* getActiveCoursesSaga(action: ActionType) {
  try {
    const res = yield call(courseManagementServices.getActiveCourses);
    yield put(courseManagementActions.setActiveCourses(res));
  } catch (e) {
    console.log(getActiveCoursesSaga, e);
  }
}

function* getBulkReportSaga(action: ActionType) {
  try {
    const res = yield call(courseManagementServices.getBulkReport, action.payload);
    yield put(courseManagementActions.setBulkReport(res));
  } catch (e) {
    console.log(getBulkReportSaga, e);
  }
}

function* rejectCourseSaga(action: ActionType) {
  try {
    const requestState = yield select((state: any) => state.courseMangementData.courseManagementReducer.requestState);
    const rejectionCourse = requestState === REQUEST_STATUS.CLOSED ? courseManagementServices.closeCourse : courseManagementServices.rejectCourse;
    const res = yield call(rejectionCourse, action.payload);
    const message = res.responseMessage;
    if (res.statusCode === 200) {
      redirectionToCourseManagement(REQUEST_STATUS.AWAITING);
    }
  } catch (e) {
    yield put(showAlertToaster(API_RESPONSE.ERROR.PROCESSING_FAILURE, VARIANT.ERROR));
  }
}

function* approveAndPublishCourseSaga(action: ActionType) {
  try {
    const { packageId, requestId } = action.payload;
    let res = yield call(courseManagementServices.approveCourse, requestId);
    if (res.statusCode === 200) {
      res = yield call(courseManagementServices.publishCourse, {id:packageId});
      redirectionToCourseManagement(REQUEST_STATUS.AWAITING);
    } 
  } catch (e) {
    yield put(showAlertToaster(API_RESPONSE.ERROR.PROCESSING_FAILURE, VARIANT.ERROR));
  }
}



// function* getActiveTreeDataSaga(action: ActionType){
//     try{
//         const res = yield call(courseManagementServices.getCousePlanApiById(action.payload))
//         yield put(
//             courseManagementActions.setTreeViewData(res)
//         )
//     } catch (e) {
//         console.log(getActiveTreeDataSaga, e)
//     }
// }

function* getUserSuggestionsSaga(action: ActionType) {
  try {
    // console.log(action.payload);
    const res = yield call(courseManagementServices.getUserSuggestions, action.payload);
    yield put(courseManagementActions.setUserSuggestions(res));
  } catch (e) {
    console.log(getUserSuggestionsSaga, e);
  }
}

function* storeGeneralSettingsSaga(action: ActionType) {
  try {
    yield put(courseManagementActions.setGeneralSettings(action.payload));
  } catch (e) {
    console.log('storeGeneralSettingsSaga', e);
  }
}

function* storeFAQSaga(action: ActionType) {
  try {
    yield put(courseManagementActions.setFAQ(action.payload));
  } catch (e) {
    console.log('storeFAQSaga', e);
  }
}

function* storeSEOSaga(action: ActionType) {
  try {
    yield put(courseManagementActions.setSEO(action.payload));
  } catch (e) {
    console.log('storeSEOSaga', e);
  }
}

function* saveAdvancedSettingsSaga(action: ActionType) {
     try {
        const res = yield call(courseManagementServices.saveAdvancedSettings, action.payload) // res gets statusCode 200 || 422
    } catch (e) {
        console.log('saveAdvancedSettingsSaga', e)
    }
}

// function* storePackageIdSaga(action: ActionType) {
//     try {
//         // yield put(

//         // )
//     } catch (e) {
//         console.log('storePackageIdSaga', e)
//     }
// }

function* fetchExistingScheduledTestsSaga(action: ActionType) {
    try {
        const res = yield call(courseManagementServices.fetchExistingScheduledTests, action.payload)
        yield put(
            courseManagementActions.setExistingScheduledTests(res)
        )
    } catch (e) {
        console.log(e)
    }
}

function* fetchMapTestSuggestionsSaga(action: ActionType) {
  try {
    
    const res = yield call(courseManagementServices.fetchMapTestSuggestions, action.payload);
    // console.log(res);
    yield put(courseManagementActions.setMapTestSuggestions(res));
  } catch (e) {
    console.log(e);
  }
}

function* fetchCoursesByScheduleID(action: ActionType) {
    try {
        // call service
        const res = yield call(courseManagementServices.fetchCoursesByScheduleId, action.payload)
        yield put(
            courseManagementActions.setCoursesByScheduleId(res)
        )
    } catch (e) {
        console.log(e)
    }
}

function* fetchScheduledTestsSaga(action: ActionType) {
  try {
    const {queryParams}=action.payload;
    let res={};
    if(queryParams){
      res=yield call(courseManagementServices.getScheduleTestsForMapping, action.payload);
    }else{
      res = yield call(courseManagementServices.fetchScheduleTests, action.payload);
    }
    // console.log(':::::res:::::::', res);
    yield put(courseManagementActions.setScheduledTests(res));
  } catch (e) {
    console.log(e);
  }
}

function* getBasicInfoSaga(action: ActionType) {
    try {
        const res = yield call(courseManagementServices.getBasicInfo, action.payload)
        console.log('res:::::::::::::::::', res)
        yield put(
            courseManagementActions.setBasicInfo(res)
        )
    } catch (e) {
        console.log(e)
    }
}

function* setBulkTestUploadDataSaga(action: ActionType) {
  try {
    yield put(contentManagementAction.setBulkUploadTestData(action.payload));
  } catch (e) {
    console.log('setBulkTestUploadDataSaga', e);
  }
}

function* getCourseDetailsSaga(action: ActionType) {
    try {
        const res = yield call(courseManagementServices.getCourseData, action.payload)
        yield put(
            contentManagementAction.setPackageData(res)
        )
    } catch (e) {
        console.log('getCourseDetailsSaga',e)
    }
}

function* setActiveTabSaga(action: ActionType) {
  try {
    yield put(contentManagementAction.setActiveTab(action.payload));
  } catch (e) {
    console.log('setActiveTabSaga', e);
  }
}

function* publishCourseSaga(action: ActionType) {
  console.log(action.payload,"publish")
  try {
    const res = yield call(courseManagementServices.publishCourse, action.payload);
    if(res.statusCode==200){
       yield put(contentManagementAction.setIsCoursePublished(true));
       redirectionToCourseManagement(REQUEST_STATUS.AWAITING);
    }
  } catch (e) {
    console.log('publishCourseSaga', e);
  }
}

const getUpdatedFaq = (faq: any) => {
  // const { faq, faq: {FAQ} } = this.props;
  let updatedFaq = { ...faq };
  let updatedFAQ = [...faq.FAQ];
  updatedFAQ = updatedFAQ.map((faq, index) => {
    return {
      question: faq.question,
      answer: faq.answer,
      sequence: index + 1,
    };
  });
  console.log(updatedFAQ);
  updatedFaq.FAQ = updatedFAQ;
  return updatedFaq;
};

const prepareBasicInfoData = (basicDetailsData: any) => {
    const basicDetails  = {...basicDetailsData};
    //basicDetails.type = CourseTypes.standard;
    let contentPreferences:any = {};
    const CONTENT_TYPES = [
      'scheduledTests',
      'chapterTests',
      'conceptTests',
      'studyNotes',
      'video',
      'sampleTests',
      'mainTests',
      'formulas',
  ]
  
    const newContentTypes=[ 'sampleTests','mainTests','formulas'];
    newContentTypes.forEach((type)=>{
      contentPreferences[type]={
        "enabled": true
      };
    });
    const contentPreferenceKeys = Object.keys(basicDetails.contentPreferences)
    contentPreferenceKeys.forEach((preference:any) => {
      if(basicDetails.contentPreferences[preference].enabled){
        if(CONTENT_TYPES.includes(preference)) {
          contentPreferences[preference] = {
            "enabled": true
          }
        } 
      }else{
          if(CONTENT_TYPES.includes(preference)) {
            contentPreferences[preference] = {
              "enabled": false
            }
          }
      }
    });
    newContentTypes.forEach((type)=>{
      if(!(contentPreferences[type] && contentPreferences[type].enabled)){
        contentPreferences[type]={
          "enabled": type=="formulas"?true:false
        };
      } 
    });
    basicDetails.contentPreferences = contentPreferences;
    // basicDetails.targetYears = basicDetails.sku && [+basicDetails.sku.split('-')[basicDetails.sku.split('-').length - 1]];
    basicDetails.targetYears = basicDetails.sku && typeof basicDetails.sku === 'object' ? 
                                basicDetails.sku && [basicDetails.sku.SKUYear] : 
                                [+basicDetails.sku.split('-')[basicDetails.sku.split('-').length-1]];
    // const goalData = this.prepareCourseDetailArray();
    basicDetails.courseDetails = basicDetails.courseDetails;
    basicDetails.sku = basicDetails.sku && typeof basicDetails.sku === 'object' ? 
                                        buildSKUString(basicDetails.sku) : 
                                        basicDetails.sku;
    basicDetails.startDate = basicDetails.startDate && typeof basicDetails.startDate === 'object' ?  basicDetails.startDate.value : basicDetails.startDate;
    basicDetails.expiryDate = (basicDetails.expiryDate && typeof basicDetails.expiryDate === 'object') || 
                              (basicDetails.endDate && typeof basicDetails.endDate === 'object') ?  
                              basicDetails.endDate.value : basicDetails.expiryDate;
   return basicDetails 
}

function* saveTabDataSaga(action: ActionType){
    try {
        const { courseId, showSuccessPopupOnComplete = false,isVersion, saveCoursePlan = false, coursePlanApiPayload, toPublish = false, master } = action.payload;
        const activeTab:any = yield select(
            (state: any) => state.courseMangementData.contentManagementData.activeTab
        );
        
        let allApiSuccess = true;
        yield put(courseManagementActions.setPollingStatus(true));
        if(!isVersion){
          yield put(courseManagementActions.setSavedSuccessfully({ key: 'advanceSettings', value: false }))
          
        }
        yield put(courseManagementActions.setSavedSuccessfully({ key: 'basicInfo', value: false }));
        // switch(activeTab){
        //     case CourseActiveTabs.coursePlan:
                   

        //         // break;
        //     case CourseActiveTabs.basicInfo:
                // console.log('---------------basic start---------------------------')
                    const basicInfo = yield select (
                        (state: any) => state.courseMangementData.courseManagementReducer.basicInfo
                    )
                    const updatedBasicInfo = prepareBasicInfoData(basicInfo);
                     const payloadBasicInfo =  {
                        courseBasicDetails: updatedBasicInfo,
                        packageId: courseId,
                      }
                    const response = yield call(courseManagementServices.updateCourseBasicDetails, payloadBasicInfo)
                    let packageChangeRequestId = '';
                    switch(response.statusCode){
                      case 200:
                        yield put(
                          courseManagementActions.setDuplicateSKUMessage([''])
                        )
                        yield put(
                          courseManagementActions.setStartEndDateError([''])
                        )
                        yield put(courseManagementActions.setSavedSuccessfully({ key: 'basicInfo', value: true }));
                        packageChangeRequestId = response.responseObject.packageChangeRequestId;
                        break;
                      case 422:

                        if(response.responseMessage === 'Duplicate SKU.'){
                          console.log('::::;;IN DUPLICATE SKU:::::::')
                          yield put(
                            courseManagementActions.setDuplicateSKUMessage(['Please enter a unique SKU'])
                          )
                        } else {
                          yield put(
                            courseManagementActions.setStartEndDateError(['Mismatch of course duration and phase duration'])
                          )
                        }



                        allApiSuccess = false;
                        showMsg('Duplicate SKU', 'error');
                        return;
                    }
                    yield put(
                        contentManagementAction.setBasicInfoDone(response)
                    )
                // break;
            // case CourseActiveTabs.advancedSettings:
                // console.log('---------------advanced settings start---------------------------')
                    const generalSettings = yield select (
                        (state: any) => state.courseMangementData.courseManagementReducer.generalSettings
                    )
                    const faq = yield select (
                        (state: any) => state.courseMangementData.courseManagementReducer.faq
                    )
                    const updatedFaq = getUpdatedFaq(faq);
                    const seo = yield select (
                        (state: any) => state.courseMangementData.courseManagementReducer.seo
                    )
                    const advancedSettings = {
                        ...generalSettings,
                        ...updatedFaq,
                        ...seo
                    }

                    advancedSettings.isPaid = advancedSettings.isPaid === 'Paid' ? true : false;
                    advancedSettings.discount = advancedSettings.discount && +advancedSettings.discount;
                    advancedSettings.price = advancedSettings.price && +advancedSettings.price;
                    advancedSettings.availableForCRP = !!advancedSettings.availableForCRP;
                    advancedSettings.availableForNCRP = !!advancedSettings.availableForNCRP;
                    advancedSettings.availableForB2C = !!advancedSettings.availableForB2C;

                    if(advancedSettings.sellsOutsideIndia){
                      delete advancedSettings.price;
                      delete advancedSettings.discount;
                    } else {
                      delete advancedSettings.localeWisePrice;
                    }
                    

                    const packageId = courseId;
                    const payload = {
                         packageId: packageId, 
                         advancedSettings: advancedSettings,
                        packageChangeRequestId
                    };
                    if(!isVersion){
                    const statusCode = yield call(courseManagementServices.saveAdvancedSettings, payload)
                    if(statusCode === 422) {
                      allApiSuccess = false;
                      return;
                    } else {
                      yield put(courseManagementActions.setSavedSuccessfully({ key: 'advanceSettings', value: true }))
                    }
                    yield put(
                        contentManagementAction.setAdvancedSettingsDone(statusCode)
                    )

                  }
                  let redirect = true;
                  if(saveCoursePlan) {
                    const coursePlanPayload = {
                      ...coursePlanApiPayload,
                      packageChangeRequestId
                    };
                    const revisedHours = yield select((state) => state.courseMangementData.contentManagementData.revisedHours);
                    const phaseUploadUrl = yield select((state) => state.courseMangementData.contentManagementData.phaseUploadUrl);
                    const response = yield call(courseManagementServices.updateCoursePlan, coursePlanPayload, revisedHours, phaseUploadUrl);
                    if(response.statusCode === 422) {
                      allApiSuccess = false;
                      yield put(showAlertToaster(response.responseMessage, VARIANT.ERROR))
                      return;
                    }
                    if (response.statusCode === 200) {
                      const noPopup = [COURSE_PLAN_RESPONSES.REQUEST_SUBMITTED_SUCCESSFULLY, COURSE_PLAN_RESPONSES.REQUEST_PUBLISHED_SUCCESSFULLY];
                      const popUp = [COURSE_PLAN_RESPONSES.CONFIRMATION_POPUP, COURSE_PLAN_RESPONSES.REQUEST_ALREADY_EXIST_FOR_ANOTHER_USER];
                      if (popUp.includes(response.responseMessage)) {
                        redirect = false;
                        yield put(courseManagementActions.setCourseChangePopup(response.responseObject));
                        yield put(courseManagementActions.setCourseChangePayload(coursePlanPayload));
                        yield put(courseManagementActions.setIsDifferentUser(response.message === COURSE_PLAN_RESPONSES.REQUEST_ALREADY_EXIST_FOR_ANOTHER_USER));
                      } else if (noPopup.includes(response.responseMessage)) {
                        yield put(showAlertToaster(response.responseMessage, VARIANT.SUCCESS));
                      }
                    }
                  }
                    const packageData = yield select((state: any) => state.courseMangementData.contentManagementData.packageData);
                    const requestId = getRequestId();
                    const editedUser = checkForCreatedByUser(packageData);
                    const publishCourseRight = toPublish && (editedUser || checkForPublishRight(MODULES.COURSE)) && !requestId;
                    if (publishCourseRight) {
                    if(allApiSuccess) {
                      let publishPayload: any = { packageChangeRequestId };
                      if (master) {
                        publishPayload = {
                          ...publishPayload,
                          id: courseId,
                          masterId: master
                        };
                      } else {
                        publishPayload = { ...publishPayload, id: courseId };
                      }
                      yield put(publishCourse(publishPayload));
                      yield put(contentManagementAction.setPublishBtnClicked(true))
                      yield put(courseManagementActions.resetToInitialState({}));
                      if (!requestId) {
                        setTimeout(() => window.location.href = '/course-Management', 500);
                      }
                    }else{
                      yield put(courseManagementActions.setPollingStatus(false));
                    }
                    } else if (allApiSuccess) {
                      redirect && redirectionToCourseListing();
                    }

                  if(showSuccessPopupOnComplete && allApiSuccess) {
                    yield put({
                        type: 'SHOW_ALERT', data: { message: 'Course Saved successfully', variant: 'success', openSnackbar: true }
                    })
                    yield put(courseManagementActions.resetSavedSuccessfully({}))
                  }
                // break;
            // default:
            
        // }
    } catch (e) {
        console.log('saveTabDataSaga',e)
    }
  
}
function* saveAdvanceSettingSaga(action: ActionType){
    try {
      yield put(courseManagementActions.setSavedSuccessfully({ key: 'advanceSettings', value: false }))
      
                    const generalSettings = yield select (
                        (state: any) => state.courseMangementData.courseManagementReducer.generalSettings
                    )
                    const faq = yield select (
                        (state: any) => state.courseMangementData.courseManagementReducer.faq
                    )
                    const updatedFaq = getUpdatedFaq(faq);
                    const seo = yield select (
                        (state: any) => state.courseMangementData.courseManagementReducer.seo
                    )
                    const advancedSettings = {
                        ...generalSettings,
                        ...updatedFaq,
                        ...seo
                    }

                    advancedSettings.isPaid = advancedSettings.isPaid === 'Paid' ? true : false;
                    advancedSettings.discount = advancedSettings.discount && +advancedSettings.discount;
                    advancedSettings.price = advancedSettings.price && +advancedSettings.price;
                    advancedSettings.availableForCRP = !!advancedSettings.availableForCRP;
                    advancedSettings.availableForNCRP = !!advancedSettings.availableForNCRP;
                    advancedSettings.availableForB2C = !!advancedSettings.availableForB2C;

                    if(advancedSettings.sellsOutsideIndia){
                      delete advancedSettings.price;
                      delete advancedSettings.discount;
                    } else {
                      delete advancedSettings.localeWisePrice;
                    }


                    const payload = { 
                         advancedSettings: advancedSettings,
                         ...action.payload
                    }
                    const statusCode = yield call(courseManagementServices.saveAdvancedSettings, payload) 
                    if(statusCode !== 422) {
                      yield put(courseManagementActions.setSavedSuccessfully({ key: 'advanceSettings', value: true }))
                    }
                    yield put(
                        contentManagementAction.setAdvancedSettingsDone(statusCode))
    } catch (e) {
        console.log('saveTabDataSaga',e)
    }
}     

const checkGeneralSettingsMandatoryFields = (generalSettings: GeneralSettings) => {
  let allMandatoryFieldsFilled = true;
  console.log('General Settings Data', generalSettings)
  const {
    sellsOutsideIndia,
    price,
    localeWisePrice
  } = generalSettings;

  if(sellsOutsideIndia){
    localeWisePrice && localeWisePrice.forEach((localPrice) => {
      const { price } = localPrice
      console.log('Price---->',price)
      if(price === undefined || price < 1){
        allMandatoryFieldsFilled = false;
      }
    })
  }
  else {
    console.log('Price---->',price)
    if(price === 0 || price === undefined){
      console.log('IN IF CONDITION')
      allMandatoryFieldsFilled = false;
    }
  }
  console.log('General Settings--------->', allMandatoryFieldsFilled)

  return allMandatoryFieldsFilled;


  // return allMandatoryFieldsFilled;
}

const checkSeoMandatoryFields = (seo: SEO) => {
  let allMandatoryFieldsFilled = true;
  console.log('SEO', seo)
  const { metatags } = seo;
  const {title, keywords, description} = metatags;
  if(title === "" || keywords === "" || description ==="") {
    console.log('SEO Mandatory fields Pending')
    allMandatoryFieldsFilled = false;
  }
  console.log('SEO mandatory fields-------->', allMandatoryFieldsFilled)
  return allMandatoryFieldsFilled;
  // return allMandatoryFieldsFilled;
}

function* checkAdvancedSettingsMandatoryFieldsSaga(action: ActionType){
  try {
    const generalSettings = yield select (
      (state: any) => state.courseMangementData.courseManagementReducer.generalSettings
    )

    const seo = yield select (
        (state: any) => state.courseMangementData.courseManagementReducer.seo
    )

    const generalSettingsMandatoryFlag = checkGeneralSettingsMandatoryFields(generalSettings)
    yield put(
      contentManagementAction.setGeneralSettingsMandatoryFlag(generalSettingsMandatoryFlag)
    )

    const seoMandatoryFlag = checkSeoMandatoryFields(seo)
    yield put(
      contentManagementAction.setSeoMandatoryFlag(seoMandatoryFlag)
    )

  } catch (e) {
    console.log('checkAdvancedSettingsMandatoryFieldsSaga',e)
  }
}

function* setSavedSuccessfullySaga(action: ActionType) {
  const { key, value } = action.payload;
  const savedSuccessfully = yield select((state: any) => state.courseMangementData.courseManagementReducer.savedSuccessfully);
  const newSavedSuccessfully = { ...savedSuccessfully, [key]: value };
  const allSuccess = Object.entries(newSavedSuccessfully).reduce((acc, [key, value]: any) => acc && value, true);
  if(allSuccess) {
    yield put({
        type: 'SHOW_ALERT', data: { message: 'Course Saved successfully', variant: 'success', openSnackbar: true }
    })
    // reset after 3 secs
    yield delay(3000);
    yield put(courseManagementActions.resetSavedSuccessfully({}))
  }
}

function* fetchContentFromPackages(action: ActionType) {
     yield put(courseManagementActions.fetchContentFromPackages({}))
     const content= yield call(courseManagementServices.getContentFromPackages,action.payload);
     yield put(courseManagementActions.setPackagesContent(content));
}

function* courseManagementSaga(){
    yield takeLatest(actionTypes.ADD_COURSE_BASIC_DETAILS, addCourseBasicDetailsSaga)
    yield takeLatest(actionTypes.UPDATE_COURSE_BASIC_DETAILS, updateCourseBasicDetailsSaga)
    yield takeLatest(actionTypes.GET_ACTIVE_GOALS, getActiveGoalsSaga)
    yield takeLatest(actionTypes.GET_ACTIVE_COURSES, getActiveCoursesSaga)
    yield takeLatest(actionTypes.GET_BULK_REPORT, getBulkReportSaga)
    yield takeLatest(actionTypes.GET_USER_SUGGESTIONS, getUserSuggestionsSaga)
    yield takeLatest(actionTypes.STORE_GENERAL_SETTINGS, storeGeneralSettingsSaga)
    yield takeLatest(actionTypes.STORE_FAQ, storeFAQSaga)
    yield takeLatest(actionTypes.STORE_SEO, storeSEOSaga)
    yield takeLatest(actionTypes.SAVE_ADVANCED_SETTINGS, saveAdvancedSettingsSaga)
    yield takeLatest(actionTypes.ADD_COURSE_TEST_SERIES, addCourseTestSeries) 
    // yield takeLatest(actionTypes.TREE_DATA_VIEW_SUCCESS,getActiveTreeDataSaga)
    // yield takeLatest(actionTypes.STORE_PACKAGE_ID, storePackageIdSaga)
    yield takeLatest(actionTypes.FETCH_EXISTING_SCHEDULED_TESTS, fetchExistingScheduledTestsSaga)
    yield takeLatest(actionTypes.FETCH_MAP_TEST_SUGGESTIONS, fetchMapTestSuggestionsSaga)
    yield takeLatest(actionTypes.COURSES_BY_SCHEDULE_ID, fetchCoursesByScheduleID)
    yield takeLatest(actionTypes.FETCH_SCHEDULED_TESTS, fetchScheduledTestsSaga)
    yield takeLatest(actionTypes.GET_BASIC_INFO, getBasicInfoSaga)
    yield takeLatest(actionTypes.SET_BULK_TEST_UPLOAD_DATA, setBulkTestUploadDataSaga)
    yield takeLatest(actionTypes.GET_COURSE_DETAILS, getCourseDetailsSaga )
    yield takeLatest(actionTypes.SET_ACTIVE_TAB, setActiveTabSaga )
    yield takeLatest(actionTypes.SAVE_TAB_DATA, saveTabDataSaga);
    yield takeLatest(actionTypes.PUBLISH_COURSE, publishCourseSaga);
    yield takeLatest(actionTypes.REJECT_COURSE, rejectCourseSaga);
    yield takeLatest(actionTypes.APPROVE_AND_PUBLISH, approveAndPublishCourseSaga);
    yield takeLatest(actionTypes.SAVE_ADVANCED_SETTING, saveAdvanceSettingSaga)
    yield takeLatest(actionTypes.CHECK_ADVANCED_SETTINGS_MANDATORY_FIELDS, checkAdvancedSettingsMandatoryFieldsSaga)
    yield takeEvery(courseManagementActions.setSavedSuccessfully.type, setSavedSuccessfullySaga)
    yield takeLatest(actionTypes.FETCH_CONTENT_FROM_PACKAGES, fetchContentFromPackages)
}

export default courseManagementSaga;
